export const veridionPageSV = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | Organisationen av AI-medarbetare",
    "description": "Nästa steg i produktivitet: Organisation as a Service. En organisation av AI-medarbetare levererar verifierat arbete, planerbart i fasta cykler, on-premises eller i ert eget moln."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "En skapare, oändligt många lösningar.",
    "claim": "Nästa steg i produktivitet: Organisation as a Service.",
    "lead": "Företags-AI:n som styr hela pAIoneer Labs GmbH: en arbetsstyrka av AI-medarbetare som integrerar sig i varje process i ert företag, slutför arbetet på egen hand och lär sig med varje uppgift. Människor anger riktningen. Allt annat sker av sig självt."
  },
  "vision": {
    "lines": [
      "Mjukvara gav företagen verktyg.",
      "AI gav dem assistenter.",
      "Veridion ger dem en organisation."
    ],
    "note": "Information rör sig på timmar, erfarenheten går i pension, tjänster förblir obesatta. Ett verktyg till löser inte det; en arbetsstyrka man inte behöver anställa gör det."
  },
  "grow": {
    "title": "Det den inte kan, skapar den själv",
    "text": "När det ännu inte finns någon förmåga för en uppgift eller något inte går att lösa med befintliga medel utvecklar Veridion själv nya, godtyckligt komplexa AI-system — AI vidareutvecklar AI självständigt: konstruerade, byggda, testade och satta i drift. Endast godkännandet ligger hos människan via [Intent-Driven Development](idd) (IDD).",
    "punch": "Det är precis vad det betyder: en skapare, oändligt många lösningar."
  },
  "integrate": {
    "title": "Mitt i era processer",
    "subtitle": "Ingen ny programvara, ingen utbildning, ingen omställning.",
    "cards": [
      {
        "title": "I företagschatten",
        "text": "Samtalet sker där era medarbetare redan skriver: Webex, Microsoft Teams, Zoom, Slack. Ett meddelande räcker."
      },
      {
        "title": "I era verktyg",
        "text": "Projektledning, repositories, arkiv: arbetet sker i de system som finns, inte vid sidan av dem."
      },
      {
        "title": "Från offerten till bokföringen",
        "text": "En process i taget, i er takt. När kapaciteten är knapp även bara ett enskilt utvecklingspaket eller ett helt projekt."
      }
    ]
  },
  "org": {
    "title": "En arbetsstyrka, organiserad som ett företag",
    "subtitle": "Vi tvingar aldrig på ett företag en stel mall: för varje företagsstruktur utformar vi ett individuellt organigram, tilldelar tydliga roller och ansvarsområden och anpassar oss flexibelt. Varje Business Unit består av AI-medarbetare som orkestreras av Veridion och arbetar helt automatiserat ända fram till [IDD](idd) Human-in-the-Loop — och när något ännu inte går utvecklar Veridion själv ny AI.",
    "execKicker": "Koordineringsnivå — helt automatiserad fram till IDD Human-in-the-Loop",
    "execTitle": "Individuellt organigram, tydliga roller och AI som själv vidareutvecklar AI.",
    "execText": "Under de mänskliga beslutsfattarna arbetar koordineringsnivån och våra Business Units av AI-medarbetare helt automatiserat: de bryter ned mål, fördelar arbete över tydligt definierade roller och ansvarsområden, löser problem självständigt och inhämtar riktade godkännanden från människan. Människan i loopen styr genom [Intent-Driven Development](idd) (IDD) — långt bortom programkod som en gemensam styrning mellan människa och AI via avsikter, beslut och verifieringsscenarier. Och närhelst en förmåga saknas konstruerar och bygger Veridion självständigt nya, godtyckligt komplexa AI-system — AI vidareutvecklar AI.",
    "units": [
      {
        "name": "Mjukvaruutveckling",
        "text": "Ansvarar för mjukvaran från krav till drift: arkitektur, kod, tester, granskningar, pipelines och kvaliteten bakom dem."
      },
      {
        "name": "Elektronik & firmware",
        "text": "Ansvarar för hårdvarusidan: kretsar, firmware och valet av varje komponent."
      },
      {
        "name": "Kvantdatorteknik & kvant-AI",
        "text": "Ansvarar för forskningen kring kvantdatorteknik och kvant-AI och gör produkter av solida resultat."
      },
      {
        "name": "Försäljning & marknadsföring",
        "text": "Ansvarar för marknaden: bevakar den, hittar målkunder, tar fram dossierer, utformar texter och offerter. Avslutet gör en människa."
      },
      {
        "name": "Produkter & plattformsdrift",
        "text": "Ansvarar för produkter och drift: strategi, prioriteringar, releaser, därtill övervakning, incidenter och kapacitet för den löpande plattformen."
      },
      {
        "name": "Administration & ekonomi",
        "text": "Ansvarar för det kommersiella: verifikat, fakturor, avtal, tidsfrister, förberett fram till underskriften, och den stannar hos er."
      }
    ]
  },
  "trust": {
    "title": "Vad ni kan förlita er på",
    "cards": [
      {
        "title": "Human-in-the-Loop & IDD långt bortom kod",
        "text": "Intent-Driven Development ([IDD](idd)) sträcker sig långt bortom programkod: det är vad människan i loopen gör tillsammans med AI:n över företagets alla områden. Människa och AI formulerar gemensamt avsikten (Intent), fattar bindande beslut (Decisions) och definierar verifierbara scenarier (Scenarios) innan AI-styrkan genomför arbetet självständigt i fasta, planerbara cykler med mänskligt godkännande."
      },
      {
        "title": "Spelteoretiskt optimerad kommunikation",
        "text": "Projektledningen och AI-medarbetarnas kommunikation är spelteoretiskt optimerade, från den enskilda AI-medarbetaren till hela affärsområdet: grundlighet och motiverad invändning betalar sig; att vinka igenom, upprepa sig och skjuta ansvaret vidare kostar. Så vinner den bästa kommunikationen."
      },
      {
        "title": "Förklarbart ända till källan",
        "text": "Explainable AI är arbetsprincipen här, inte ett tillägg: varje resultat redovisar öppet vad det har uppstått ur, passagerna i företagskunskapen, datan, beräkningsvägen. Det som saknar belägg påstås inte."
      },
      {
        "title": "Lär sig på egen hand",
        "text": "De egna nyckeltalen läses efter varje varv och de egna reglerna justeras därefter: varje löpande projekt gör helheten bättre."
      }
    ]
  },
  "daily": {
    "title": "Vad som tas över redan i dag",
    "subtitle": "Varje dag, tvärs igenom företaget.",
    "items": [
      {
        "title": "Utveckling",
        "text": "Kod, tester och dokumentation ur fastlagda beslut. Modernisering av äldre programvara med golden master- och back-to-back-bevis."
      },
      {
        "title": "Elektronik & firmware",
        "text": "Analysera datablad, simulera kretsar som digitala tvillingar, utveckla firmware och bedöma komponentalternativ innan något tillverkas, nära hårdvaran ända ned till sensorn."
      },
      {
        "title": "Kvantforskning",
        "text": "Läsa forskningsfronten, bygga och utvärdera reproducerbara experiment mot klassiska jämförelsebaser, varje resultat spårbart dokumenterat."
      },
      {
        "title": "Dataanalys",
        "text": "SQL Server, MariaDB, MySQL och Oracle: typad analysplan, uteslutande läsande frågor, statistik ur körmiljön, rapporter ur ett versionerat resultat."
      },
      {
        "title": "Administration & ekonomi",
        "text": "Bokföring, redovisning och byråkratin i ett bolag: läsa, sortera och arkivera verifikat; utkast till fakturor och avtal ingår."
      },
      {
        "title": "Projekt & uppgifter",
        "text": "Ett mötestranskript blir utan omvägar uppgifter i projektledningen, och framstegen flödar tillbaka: nästa möte börjar från aktuellt läge."
      },
      {
        "title": "Företagskunskap",
        "text": "En kunskapsbas för dokument och en grafdatabas som kopplar samman uppgifter, beslut, personer och system: sammanhang över veckor och över projektgränser."
      },
      {
        "title": "Research på internet",
        "text": "Det som företagskunskapen inte har researchas fram: de bästa sidorna söks upp och läses, och i slutet står en rapport där varje påstående har sin numrerade källa."
      },
      {
        "title": "Tal & möten",
        "text": "Hela företaget kan ledas på språng: talade samtal utför samma arbete som chatten, även i telefonen på resande fot."
      },
      {
        "title": "Kontorsarbete med RoBuddy",
        "text": "RoBuddy täcker arbetsplatsen: tidsbokningar, e-post, utbildningar och dataskyddsfrågor. Enheterna täcker resten av företaget."
      }
    ]
  },
  "operate": {
    "title": "Drift",
    "cards": [
      {
        "title": "On-premises eller eget moln",
        "text": "I förväg räknar vi tillsammans på vilka processer som bär sig: return on investment och totalkostnad redovisas öppet. Driften sker på er hårdvara eller i ert eget moln, utan att något dokument lämnar huset."
      },
      {
        "title": "Hos oss",
        "text": "pAIoneer Labs GmbH är uppbyggt så från grunden: våra projekt, vår företagskunskap och vår administration löper genom Veridion. Organisationen utvecklar själv [tradingassistenten](finance) på vår plattform och är AI:n i dess chatt."
      }
    ]
  },
  "cta": {
    "title": "Förfrågan",
    "subtitle": "Som serverprogramvara i er infrastruktur. Priset anger vi på förfrågan.",
    "button": "Skicka förfrågan",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
